import type { LucideIcon } from 'lucide-react'
import { Bug, Lightbulb, MessageCircle, Sparkles } from 'lucide-react'

import type { FeedbackCategory, FeedbackStatus } from '@/api/feedback'

export const FEEDBACK_CATEGORY_META: Record<
  FeedbackCategory,
  { icon: LucideIcon; tone: string; badge: string }
> = {
  bug: {
    icon: Bug,
    tone: 'text-rose-300',
    badge: 'border-rose-500/30 bg-rose-500/10 text-rose-200',
  },
  suggestion: {
    icon: Lightbulb,
    tone: 'text-indigo-300',
    badge: 'border-indigo-500/30 bg-indigo-500/10 text-indigo-200',
  },
  experience: {
    icon: Sparkles,
    tone: 'text-amber-300',
    badge: 'border-amber-500/30 bg-amber-500/10 text-amber-200',
  },
  other: {
    icon: MessageCircle,
    tone: 'text-zinc-300',
    badge: 'border-zinc-500/30 bg-zinc-500/10 text-zinc-200',
  },
}

export const FEEDBACK_STATUS_TONE: Record<FeedbackStatus, string> = {
  pending: 'border-amber-500/30 bg-amber-500/10 text-amber-200',
  rewarded: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-200',
  rejected: 'border-zinc-500/30 bg-zinc-500/10 text-zinc-300',
}

export function isVideoUrl(url: string): boolean {
  return /\.(mp4|webm|mov)(\?|$)/i.test(url)
}

export function formatFeedbackDateTime(iso?: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function previewFeedbackContent(content: string, max = 96): string {
  const trimmed = content.trim()
  if (trimmed.length <= max) return trimmed
  return `${trimmed.slice(0, max)}…`
}
